export default __webpack_public_path__ + "static/media/close_modal_2.c59bdf40.svg";